import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable';
import { LabApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)

@Injectable()
export class DeltaCheckConfigurationService extends ServiceBase {

    private actionUrl: string;

    private _getProfiles: string;
    private _addProfile: string;
    private _updateProfile: string;
    private _getProfileById: string;
    private _getProfileByCode: string;

    private _getTestRules: string;
    private _getTestRuleById: string;
    private _addTestRule: string;
    private _updateTestRule: string;

    private _getMappings: string;
    private _addMapping: string;
    private _deleteMapping: string;

    constructor(
        private _http: HttpClient,
        private _configuration: LabApiConfiguration,
        private _router: Router
    ) {
        super();
        this.actionUrl = _configuration.server;

        this._getProfiles = this.actionUrl + _configuration.deltaCheckConfiguration.getProfiles;
        this._addProfile = this.actionUrl + _configuration.deltaCheckConfiguration.addProfile;
        this._updateProfile = this.actionUrl + _configuration.deltaCheckConfiguration.updateProfile;
        this._getProfileById = this.actionUrl + _configuration.deltaCheckConfiguration.GetProfileById;
        this._getProfileByCode = this.actionUrl + _configuration.deltaCheckConfiguration.GetProfileByCode;


        this._getTestRules = this.actionUrl + _configuration.deltaCheckConfiguration.getTestRules;
        this._getTestRuleById = this.actionUrl + _configuration.deltaCheckConfiguration.getTestRuleById;
        this._addTestRule = this.actionUrl + _configuration.deltaCheckConfiguration.addTestRule;
        this._updateTestRule = this.actionUrl + _configuration.deltaCheckConfiguration.updateTestRule;

        this._getMappings = this.actionUrl + _configuration.deltaCheckConfiguration.getMappings;
        this._addMapping = this.actionUrl + _configuration.deltaCheckConfiguration.addMapping;
        this._deleteMapping = this.actionUrl + _configuration.deltaCheckConfiguration.deleteMapping;
    }

    //DeltaRuleProfile
    getProfiles = (filter: any): Observable<any> => {
        return this._http.post<any>(this._getProfiles, JSON.stringify(filter));
    }

    addProfile = (data: any): Observable<any> => {
        return this._http.post<any>(this._addProfile, JSON.stringify(data));
    }

    updateProfile = (data: any): Observable<any> => {
        return this._http.put<any>(this._updateProfile, JSON.stringify(data));
    }

    getProfileById = (id: number): Observable<any> => {
        const url = `${this._getProfileById}/${id}`;
        return this._http.get<any>(url);
    }

    getProfileByCode = (code: string): Observable<any> => {
        const url = `${this._getProfileByCode}/${code}`;
        return this._http.get<any>(url);
    }

    //DeltaTestRule
    getTestRules = (filter: any): Observable<any> => {
        return this._http.post<any>(this._getTestRules, JSON.stringify(filter));
    }

    getTestRuleById = (id: number): Observable<any> => {
        const url = `${this._getTestRuleById}/${id}`;
        return this._http.get<any>(url);
    }

    addTestRule = (data: any): Observable<any> => {
        return this._http.post<any>(this._addTestRule, JSON.stringify(data));
    }

    updateTestRule = (data: any): Observable<any> => {
        return this._http.put<any>(this._updateTestRule, JSON.stringify(data));
    }

    //TestDeltaMapping 
    getMappings = (filter: any): Observable<any> => {
        return this._http.post<any>(this._getMappings, JSON.stringify(filter));
    }

    addMapping = (data: any): Observable<any> => {
        return this._http.post<any>(this._addMapping, JSON.stringify(data));
    }

    deleteMapping = (mappingId: number): Observable<any> => {
        const url = `${this._deleteMapping}/${mappingId}`;
        return this._http.delete(url);
    }

    getTestMapping = (testId: number): Observable<any> => {
        return this._http.post<any>(this._getMappings, JSON.stringify({ TestId: testId }));
    }
}